/**
 * Конфигурации динамических фильтров для слоёв карты
 * Каждая конфигурация описывает как извлекать и фильтровать значения атрибута
 */

export const DYNAMIC_FILTERS_CONFIG = {
    // Зоны ограничений конкурентов - фильтр по операторам
    COMPETITORS_RESTRICTION_ZONES_OPERATORS: {
        layerId: 'Зоны ограничений (конкуренты)',
        sourceLayer: 'martin.competitors_restriction_zones_mvt',
        attributeName: 'operator',
        stateKeyDisabled: 'competitorsRestrictionZonesOperatorsDisabled',
        stateKeyAvailable: 'competitorsRestrictionZonesAvailableOperators',
        fallbackValues: [ 'Yandex', 'Yango', 'Yandex/Yango', 'Urent', 'Jet', 'Lime', 'Bolt', 'Voi', 'LetsGo', 'Eleven', 'Lite' ],
        additionalLayerIds: [
            'Зоны ограничений (конкуренты)_lines',
            'Зоны ограничений (конкуренты)_text',
        ],
    },

    // Зоны катания конкурентов - фильтр по компаниям
    RIDING_ZONES_COMPETITORS_COMPANIES: {
        layerId: 'Зоны катания (конкуренты)',
        sourceLayer: 'martin.areas_competitors_mvt',
        attributeName: 'company',
        stateKeyDisabled: 'ridingZonesCompetitorsOperatorsDisabled',
        stateKeyAvailable: 'ridingZonesCompetitorsAvailableOperators',
        fallbackValues: [ 'Yandex', 'Yango', 'Yandex/Yango', 'Urent', 'Jet', 'Lime', 'Bolt', 'Voi', 'LetsGo', 'Eleven', 'Lite' ],
        additionalLayerIds: [],
    },

    // Парковки конкурентов - фильтр по операторам (DA-13627)
    COMPETITORS_PARKINGS_OPERATORS: {
        layerId: 'Парковки (конкуренты)',
        sourceLayer: 'martin.hexes_for_attention_clustered_mvt',
        attributeName: 'operator',
        stateKeyDisabled: 'competitorsParkingsOperatorsDisabled',
        stateKeyAvailable: 'competitorsParkingsAvailableOperators',
        fallbackValues: [ 'Yandex', 'Yango', 'Yandex/Yango', 'Urent', 'Jet', 'Lime', 'Bolt', 'SmartBike', 'Voi', 'LetsGo', 'Eleven', 'Lite' ],
        additionalLayerIds: [],
    },

    // Административные границы OSM — фильтр по уровням (DA-13054)
    OSM_ADMIN_BOUNDARIES_LEVELS: {
        layerId: 'Административное деление',
        sourceLayer: 'martin.osm_admin_boundaries_mvt',
        attributeName: 'admin_level',
        stateKeyDisabled: 'osmAdminBoundariesLevelsDisabled',
        stateKeyAvailable: 'osmAdminBoundariesAvailableLevels',
        fallbackValues: [ '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '14' ],
        additionalLayerIds: [
            'Административное деление_line',
            'Административное деление_labels',
        ],
    },

    // Переброски флота конкурентов — фильтр по операторам (DA-13611)
    COMPETITORS_FLEET_TRANSFERS_OPERATORS: {
        layerId: 'Переброски флота (конкуренты)',
        sourceLayer: 'martin.competitors_fleet_transfers_mvt',
        attributeName: 'operator',
        stateKeyDisabled: 'competitorsFleetTransfersOperatorsDisabled',
        stateKeyAvailable: 'competitorsFleetTransfersAvailableOperators',
        fallbackValues: [ 'Yandex', 'Yango', 'Yandex/Yango', 'Urent', 'Jet', 'Lime', 'Bolt', 'SmartBike', 'LetsGo', 'Eleven' ],
        additionalLayerIds: [
            'Переброски флота (конкуренты)_arrows',
            'Переброски флота (конкуренты)_labels',
        ],
    },

    // Изменения зон конкурентов — фильтр по операторам (DA-14686)
    // additionalLayerIds: [] — фильтрация по record_type отличается для каждого слоя,
    // поэтому применяется через кастомный setCompetitorsZonesChangesFilter в Map.jsx
    COMPETITORS_ZONES_CHANGES_OPERATORS: {
        layerId: 'Изменения зон (конкуренты)',
        sourceLayer: 'martin.competitors_zones_changes_mvt',
        attributeName: 'company',
        stateKeyDisabled: 'competitorsZonesChangesOperatorsDisabled',
        stateKeyAvailable: 'competitorsZonesChangesAvailableOperators',
        fallbackValues: [ 'Yandex', 'Yango', 'Yandex/Yango', 'Urent', 'Jet', 'Lime', 'Bolt', 'Voi', 'LetsGo', 'Eleven' ],
        additionalLayerIds: [],
    },

    // Изменения парковок конкурентов — фильтр по операторам (DA-15432)
    // additionalLayerIds: [] — знаки и радиусы фильтруются вместе с основным слоем
    // через кастомный setCompetitorsParkingsChangesFilter в Map.jsx
    COMPETITORS_PARKINGS_CHANGES_OPERATORS: {
        layerId: 'Изменения парковок (конкуренты)',
        sourceLayer: 'martin.competitors_parkings_changes_mvt',
        attributeName: 'operator',
        stateKeyDisabled: 'competitorsParkingsChangesOperatorsDisabled',
        stateKeyAvailable: 'competitorsParkingsChangesAvailableOperators',
        fallbackValues: [ 'Yandex', 'Yango', 'Yandex/Yango', 'Urent', 'Jet', 'Lime', 'Voi', 'LetsGo', 'Eleven', 'SmartBike' ],
        additionalLayerIds: [],
    },
};

/**
 * Получить конфигурацию фильтра по ключу
 * @param {string} key - Ключ конфигурации
 * @returns {Object} - Конфигурация фильтра
 */
export const getFilterConfig = key => DYNAMIC_FILTERS_CONFIG[key];
